// Cost group (MPK) model shared by the fixed costs, the plan editor and the
// reports (decision 2026-10-29-grupy-kosztow-i-budzet); no HTTP here, so pure
// report models can import it. The API lives in api/companyCostGroupsApi.ts.

export interface CompanyCostGroup {
  id: string;
  name: string;
  sortOrder: number;
  isActive: boolean;
  /** Recurring costs and month lines pointing at the group (list only). */
  templateCount?: number;
  entryCount?: number;
}

/** Key of the costs without a group in the income statement's `byGroup`. */
export const UNGROUPED_COST_GROUP = 'none';

export function normalizeCompanyCostGroup(value: unknown): CompanyCostGroup | null {
  const source = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  if (typeof source.id !== 'string' || typeof source.name !== 'string') return null;
  return {
    id: source.id,
    name: source.name,
    sortOrder: Number(source.sortOrder) || 0,
    isActive: source.isActive !== false,
    ...(source.templateCount !== undefined ? { templateCount: Number(source.templateCount) || 0 } : {}),
    ...(source.entryCount !== undefined ? { entryCount: Number(source.entryCount) || 0 } : {}),
  };
}

/** Options of a group select: active groups, plus the row's own archived group. */
export function groupOptions(groups: CompanyCostGroup[], currentId?: string | null): CompanyCostGroup[] {
  return groups.filter((group) => group.isActive || group.id === currentId);
}
